import Instance from '../../../utils/Axios';

const InfoGraficos = () => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .get('/dashboard')
      .then(({ data }) => {
        if (stateToken) {
          dispatch({ type: 'GET_INFO_GRAFICOS', payload: data.yData });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default InfoGraficos;
